// Suggerimento del nome EA per un giocatore della rosa.
//
// I nomi EA sono gamertag ("santese10", "Gianluca_Monaco_", "vitte9874"):
// spesso contengono il cognome, il nome o il loro inizio. Il suggerimento e'
// solo una proposta da confermare: si restituisce un nome soltanto quando e'
// l'unico con il punteggio migliore, altrimenti niente.

export type FreeEaName = { ea_name: string; matches: number; last_played: string | null };

const norm = (s: string) =>
  s
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");

function scoreName(eaName: string, firstName: string, lastName: string): number {
  const ea = norm(eaName);
  const first = norm(firstName);
  const last = norm(lastName);
  if (!ea) return 0;
  let score = 0;
  if (last.length >= 4 && ea.includes(last)) score = Math.max(score, 100);
  if (first.length >= 4 && ea.includes(first)) score = Math.max(score, 60);
  // Inizio del cognome o del nome ("vitte" per Vitteritti, "raff" per Raffaele).
  for (const [word, base] of [[last, 50], [first, 30]] as const) {
    for (let len = Math.min(word.length - 1, 6); len >= 4; len--) {
      if (ea.includes(word.slice(0, len))) {
        score = Math.max(score, base + len);
        break;
      }
    }
  }
  // Nome e cognome insieme valgono piu' di uno solo.
  if (last.length >= 4 && first.length >= 4 && ea.includes(last) && ea.includes(first)) score = 120;
  return score;
}

export function suggestEaName(
  names: FreeEaName[],
  firstName: string | null | undefined,
  lastName: string | null | undefined,
): FreeEaName | null {
  const scored = names
    .map((n) => ({ n, score: scoreName(n.ea_name, firstName || "", lastName || "") }))
    .filter((x) => x.score > 0)
    .sort((a, b) => b.score - a.score);
  if (scored.length === 0) return null;
  if (scored.length > 1 && scored[1].score === scored[0].score) return null;
  return scored[0].n;
}
